import React from 'react';
import { Link } from 'react-router-dom';
import { StaticRoutePaths } from '../Common/ClientRoutes';
import Modal from 'react-bootstrap4-modal';
import moment from 'moment';
import { getStatusMessage, updateOrder, deleteOrder } from './epics-orders';
import Slider from '../Common/components/Slider';

import Svgs from '../Common/Svgs';
import Images from '../Common/Images';
import { MainBtn } from '../Common/form/Elements-export';
import { ImageRotation } from '../Common/DefaultStyle';
import { calculateRotation, unitAbbr } from '../Common/Helpers';

import localStorage from '../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';
//import {forEach} from "ramda";
let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

class OrderDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      medications: this.props.orderDetails.medications,
      payment: this.props.orderDetails.payment,
      deliverTo: this.props.orderDetails.deliverTo,
      orderHasUnpriced: false,

      expandedRows : [],
      note: this.props.orderDetails.note,
      pharmacistName: this.props.orderDetails.pharmacistName,
      user: {
        name: this.props.orderDetails.user.name,
        phone: this.props.orderDetails.user.phone,
        address: {
          name: this.props.orderDetails.user.address ? this.props.orderDetails.user.address.name : strings.not_set
        },
        insuranceCards: {
          primaryCardNumber: this.props.orderDetails.user.insuranceCards.primaryCardNumber ? this.props.orderDetails.user.insuranceCards.primaryCardNumber : strings.not_set,
          primaryCardImageURL: this.props.orderDetails.user.insuranceCards.primaryCardImageURL ? this.constructImageLink(this.props.orderDetails.user.insuranceCards.primaryCardImageURL) : Images.UPLOAD_PLACEHOLDER,
          primaryCardBackImageURL: this.props.orderDetails.user.insuranceCards.primaryCardBackImageURL ? this.constructImageLink(this.props.orderDetails.user.insuranceCards.primaryCardBackImageURL) : Images.UPLOAD_PLACEHOLDER,
          
          secondaryCardNumber: this.props.orderDetails.user.insuranceCards.secondaryCardNumber ? this.props.orderDetails.user.insuranceCards.secondaryCardNumber : strings.not_set,
          secondaryCardImageURL: this.props.orderDetails.user.insuranceCards.secondaryCardImageURL ? this.constructImageLink(this.props.orderDetails.user.insuranceCards.secondaryCardImageURL) : Images.UPLOAD_PLACEHOLDER,
          secondaryCardBackImageURL: this.props.orderDetails.user.insuranceCards.secondaryCardBackImageURL ? this.constructImageLink(this.props.orderDetails.user.insuranceCards.secondaryCardBackImageURL) : Images.UPLOAD_PLACEHOLDER,
          
          hasPrimaryFront: !!this.props.orderDetails.user.insuranceCards.primaryCardImageURL,
          hasPrimaryBack: !!this.props.orderDetails.user.insuranceCards.primaryCardBackImageURL,
          
          hasSecondaryFront: !!this.props.orderDetails.user.insuranceCards.secondaryCardImageURL,
          hasSecondaryBack: !!this.props.orderDetails.user.insuranceCards.secondaryCardBackImageURL,
        }
      },

      activeMedicationImageURL: '',
      modalMedicationImageOpen: false,
      activeMedicationImageStyle: ImageRotation,
      
      insurancePrimaryArray: [],
      insuranceSecondaryArray: [],
      primaryFrontStyle: ImageRotation,
      primaryBackStyle: ImageRotation,
      secondaryFrontStyle: ImageRotation,
      secondaryBackStyle: ImageRotation,
      modalSliderOpen: false,
      selectedInsuranceCard: [],
      
      createdOn: moment(this.props.orderDetails.createdOn).format('HH:mm') + ' ' + strings.on + ' ' + moment(this.props.orderDetails.createdOn).format('DD MMM YYYY'),
      activeOn: moment(this.props.orderDetails.activeOn).format('HH:mm') + ' ' + strings.on + ' ' + moment(this.props.orderDetails.activeOn).format('DD MMM YYYY'),
      completedOn: moment(this.props.orderDetails.completedOn).format('HH:mm') + ' ' + strings.on + ' ' + moment(this.props.orderDetails.completedOn).format('DD MMM YYYY'),
      
      status: this.props.orderDetails.status,
      statusMessage: '',
      modalStatusMsgOpen: false,
      modalDeleteOrder: false,
      modalInfoOrder: false,
      savingStatus: false,
      savingMessage: false,
      statusError: false
    };
  }
  
  updateStatusMessage = e => {
    this.setState({ ...this.state, statusMessage: e.target.value });
  }

  closeMedicationImageModal = () => {
    this.setState({ ...this.state, modalMedicationImageOpen: false, activeMedicationImageStyle: ImageRotation });
  }
  
  openSliderModal = insuranceCard => {
    this.setState({ ...this.state, selectedInsuranceCard: insuranceCard, modalSliderOpen: true});
  };
  
  closeSliderModal = () => {
    this.setState({ ...this.state, modalSliderOpen: false});
  };
  
  openStatusMsgModal = () => {
    this.setState({ ...this.state, modalStatusMsgOpen: true});
  }
  
  closeStatusMsgModal = () => {
    this.setState({ ...this.state, modalStatusMsgOpen: false});
  }

  openDeleteOrderModal = () => {
    this.setState({ ...this.state, modalDeleteOrder: true});
  }

  closeDeleteOrderModal = () => {
    this.setState({ ...this.state, modalDeleteOrder: false});
  }

  openInfoOrderModal = () => {
    this.setState({ ...this.state, modalInfoOrder: true});
  }

  closeInfoOrderModal = () => {
    this.setState({ ...this.state, modalInfoOrder: false});
  }
  
  constructImageLink = (image) => {
    return `${image}?access_token=${localStorage.getToken('token')}`;
  };
  
  handleRowClick = rowId => {
    const currentExpandedRows = this.state.expandedRows;
    const isRowCurrentlyExpanded = currentExpandedRows.includes(rowId);
    
    const newExpandedRows = isRowCurrentlyExpanded ?
      currentExpandedRows.filter(id => id !== rowId) :
      currentExpandedRows.concat(rowId);
    
    this.setState({ ...this.state, expandedRows : newExpandedRows});
  };
  
  renderItemArrow = rowId => {
    const currentExpandedRows = this.state.expandedRows;
    const isRowCurrentlyExpanded = currentExpandedRows.includes(rowId);
    
    if (isRowCurrentlyExpanded) {
      return <i className="fa fa-chevron-down pl-2 clickable small" onClick={() => this.handleRowClick(rowId)} />;
    } else {
      return <i className="fa fa-chevron-right pl-2 clickable small" onClick={() => this.handleRowClick(rowId)} />;
    }
  };
  
  countArticles = articles => {
    let moreThanOne = articles.length > 1 ? 's' : '';
    return '(' + articles.length + ' item' + moreThanOne + ')';
  };
  
  articleRowStyle = (articleIndex, articlesLength) => {
    let rowStyle = '';
    
    if (articleIndex%2 === 0) {
      rowStyle += ' qf-article-background';
    }
    
    if (articleIndex === 0) {
      rowStyle += ' pt-1';
    }
    
    if (articleIndex + 1 === articlesLength) {
      rowStyle += ' pb-1';
    }
    
    return rowStyle;
  }

  generateMedicationQuantity = (quantity, unit) => {
    let quantityString = '';

    if (quantity) {
      quantityString += quantity;
      if (unit) {
        quantityString += ' ' + unitAbbr(unit);
      }
    }

    return quantityString;
  };

  showMedicationImage = image => {
    let url = this.constructImageLink(image);
    this.setState({ ...this.state, modalMedicationImageOpen: true, activeMedicationImageURL: url });
  };

  generateMedicationPrice(price){
    let priceString = 'N/A';
    if(price){
      priceString = price;
    }
    return priceString;
  }

  calcMedicationRowTotal(medication){
    let priceString = 'N/A';
    if(medication.price){
      let rowTotal = medication.amount * medication.price;
      priceString = (Math.round(rowTotal * 100) / 100).toFixed(2); +' CHF';
    }
    return priceString;
  }

  generateOrderTotal(){
    console.log(this.state);
    return (
        <div className="orderTotalContainer text-right col-4 pt-3">
          <div className="orderAmount"><span>{strings.order_total}:</span> <strong>{this.computeOrderTotal(this.state.medications)}</strong></div>
          <div className="orderMethod"><span>{strings.delivery}:</span> <strong>{this.fetchDeliveryMethod(this.state.deliverTo)}</strong></div>
          <div className="orderMethod"><span>{strings.method_of_payment}:</span> <strong>{this.fetchPaymentMethod(this.state.payment)}</strong></div>
        </div>
    )
  }

  fetchDeliveryMethod(method){
    let deliveryMethod = '';
    switch (method) {
      case 'atHome':
        deliveryMethod = strings.at_home;
        break;
      case 'withCourier':
        deliveryMethod = strings.with_courier;
        break;
      case 'inPharmacy':
        deliveryMethod = strings.in_pharmacy;
        break;
    }
    return deliveryMethod;
  }

  fetchPaymentMethod(method){
    let paymentMethod = '';

    switch (method) {
      case 'on_delivery':
        paymentMethod = strings.paid_on_delivery;
        break;
      case 'credit_card':
        paymentMethod = strings.paid_card;
        break;
      case 'paypal_account':
        paymentMethod = strings.paid_paypal;
        break;
      default:
        paymentMethod = strings.paid_on_delivery;
        break;
    }
    return paymentMethod;
  }
  
  generateMedicationList = () => {
    return (
      <div className="pb-3 qf-orders-list ">
        {this.state.medications.map((medication, index) => {
          return (
            <div key={index}>
              
              <div className={'row qf-medication-row ' +(index%2 ===0 ? 'qf-medication-background' : '')} >
                
                <div className="col-1 p-1 pl-3 qf-medication-image-wrapper">
                  {medication.imageURL !== undefined ? (
                    // <img
                    //   className="qf-medication-image"
                    //   src={this.constructImageLink(medication.imageURL)}
                    //   alt="" />
                    <div 
                      className="qf-medication-image-box clickable" 
                      style={{ backgroundImage: 'url(' + this.constructImageLink(medication.imageURL) + ')'}} 
                      onClick={() => this.showMedicationImage(medication.imageURL)}
                    ></div>
                  ) : (
                    <span className="qf-medication-placeholder">
                      {Svgs.medicationPlaceholder}
                    </span>
                  )}
                </div>
                
                <div className="col-8 d-flex flex-column py-2">
                  <p className="order-product-name m-0"><span>
                    {medication.name}
                    {medication.articles ? ' ' + this.countArticles(medication.articles) : null}
                    {medication.articles ? this.renderItemArrow(index) : null}
                  </span></p>
                  <p className="order-product-note m-0"><i>{medication.note}</i></p>
                </div>
                
                <div className="col-1 text-center d-flex">
                  <span>{medication.amount}</span>
                </div>
                <div className="col-1 text-center d-flex">
                  <span>{this.generateMedicationPrice(medication.price)}</span>
                </div>
                <div className="col-1 text-center d-flex">
                  <span>{this.calcMedicationRowTotal(medication)}</span>
                </div>
              </div>

              
              {this.state.expandedRows.includes(index) && medication.articles ? medication.articles.map((article, articleIndex) => {
                return (
                  <div className={'row qf-medication-row' + this.articleRowStyle(articleIndex, medication.articles.length)} key={'article_'+articleIndex}>
                    <div className="col-1 offset-1 qf-medication-image-wrapper">
                      {article.imageURL !== undefined ? (
                        <div 
                          className="qf-medication-image-box clickable" 
                          style={{ backgroundImage: 'url(' + this.constructImageLink(article.imageURL) + ')'}} 
                          onClick={() => this.showMedicationImage(article.imageURL)} 
                        ></div>
                        // <div className="clickable" onClick={() => this.showMedicationImage(article.imageURL)}>
                        //   <img
                        //     className="qf-medication-image"
                        //     src={this.constructImageLink(article.imageURL)}
                        //     alt="" 
                        //   />
                        // </div>
                      ) : (
                        <span className="qf-medication-placeholder">
                          {Svgs.medicationPlaceholder}
                        </span>
                      )}
                    </div>
                    <div className="col-7 d-flex" >
                      <span>
                        {article.name}{article.packageType ? ', ' + strings[article.packageType]  : ''}
                      </span>
                    </div>
                    <div  className="col-1 text-center p-0 d-flex">
                      <span>
                        {article.packageSize ? article.packageSize : ''}
                      </span>
                    </div>
                    <div  className="col-1 text-center p-0 d-flex">
                      <span>
                        {article.quantity ? this.generateMedicationQuantity(article.quantity, article.unit) : ''}
                      </span>                 
                    </div>
                    <div  className="col-1 text-center p-0 d-flex">
                      <span>{article.amount}</span>
                    </div>
                  </div>
                )
              }) : null}
            </div>
          
          )
        })}
      </div>
    )
  }
  
  generateOrderInfoLine = (title, value, columns) => {
  	let colcount = 12;
  	if(columns){
	    colcount = colcount/columns;
    }
  	let classString1 = "col-"+colcount+" color-dark-gray";
  	let classString2 = "col-"+colcount+" color-light-blue mb-1 qf-medium-text";
    return (
      <div className="row mb-1">
        <div className={classString1}>{title}</div>
        <div className={classString2}>{value}</div>
      </div>
    )
  }

  computeOrderTotal = (articles) => {
    let orderSum = 0;
    let self = this;
    articles.forEach(item => {
      if(item.price){
        orderSum+=parseFloat(item.price)*item.amount;
      }else {
        self.state.orderHasUnpriced = true;
      }
    });
    if(self.state.orderHasUnpriced){
      return "N/A";
    }else{
      return (Math.round(orderSum * 100) / 100).toFixed(2) + " CHF";
    }

  }

  changeStatus = changeStatus => {
    if (!this.state.savingStatus) {
      
      this.setState({ ...this.state, savingSatus: true, statusError: false });
      
      getStatusMessage(this.props.orderDetails.id, changeStatus)
        .then(response => {
          console.log('response', response);
          this.setState({
            ...this.state,
            savingSatus: false,
            status: changeStatus,
            statusMessage: response,
            modalStatusMsgOpen: true
          });
          
        })
        .catch(error => {
          console.log(error);
        });
    }
    
  }

  deleteOrderModal = () => {
    this.setState({ ...this.state, modalDeleteOrder: true});
  }

  infoOrderModal = () => {
    this.setState({ ...this.state, modalInfoOrder: true});
  }

  deleteOrder = () => {
    deleteOrder(this.props.orderDetails.id)
      .then(response => {
        this.setState({ ...this.state, modalDeleteOrder: false});
      })
      .catch(error => {
        console.log(error);
      });
  }

  changeStatusMessage = () => {
    this.setState({ ...this.state, savingMessage: true });
      
    let data = {
      status: this.state.status,
      message: this.state.statusMessage
    }
    
    updateOrder(this.props.orderDetails.id, data)
      .then(response => {
        this.setState({ ...this.state, savingMessage: false, modalStatusMsgOpen: false });
      })
      .catch(error => {
        console.log(error);
      });
  }
  
  generateStatus = (status, title, disabled) => {
    return (
      <div className="col-12 color-light-blue qf-big-text">
        <input
          type="radio"
          id={status}
          disabled={disabled}
          name="status"
          value={status}
          checked={this.state.status === status}
          onChange={() => this.changeStatus(status)}
        />
        <label className={'qf-radio-'+status} htmlFor={status}>
          {title}
        </label>
      </div>
    )
  }

  statusIconClass(status) {
    let classComp = "fa fa-info-circle mr-2 order-status-icon "+status;
    return classComp;
  };

  fetchStatusLabel(status, noprefix) {
    let string = '';
    if(!noprefix){
      string = strings.change_status_to + ' ';
    }

    switch (status) {
      case 'pending':
        string += strings.pending_order;
        break;
      case 'inTransit':
        string += strings.accept_order;
        break;
      case 'canceled':
        string += strings.cancel_order;
        break;
      case 'ready':
        string += strings.order_ready;
        break;
      default:
    }

    return string;
  };
  
  rotateImage = (image, direction) => {
    let rotate = this.state[image + 'Style'].rotation;
    
    this.setState({
      ...this.state,
      [image + 'Style']: {
        rotation: calculateRotation(rotate, direction),
        width: `${this[image + 'Holder'].clientHeight}px`,
        height: `${this[image + 'Holder'].clientWidth}px`
      }
    });
  };
  
  constructRotationAngle = (degrees) => {
    return `rotate(${degrees}deg)`;
  };
  
  generateStyle = (type) => {
    return {
      transform: this.constructRotationAngle(this.state[type + 'Style'].rotation),
      maxHeight: this.state[type + 'Style'].height,
      maxWidth: this.state[type + 'Style'].width
    };
  };
  
  generateInsuranceCardSlides = () => {
    return this.state.selectedInsuranceCard.map((insurance, index) => {
      
      return (
        <div key={index} className="col-10 h-100 qf-insurance-slider-content">
          <div className="h-100">
            <div className="qf-h-90 text-center" ref={div => (this[insurance.type + 'Holder'] = div)}>
              <span className="qf-helper" />
              <h2>{insurance.title}</h2>
              <div className="qf-slider-img">
                <img src={insurance.cardImage}
                     style={this.generateStyle(insurance.type)}
                     alt={insurance.cardNumber}
                     className="mx-auto"
                />
              </div>
            </div>
            <div className="qf-h-10 qf-insurance-card-info text-center p-2">
              <div>
                <a className="qf-cursor-pointer mr-3"
                   onClick={() => this.rotateImage(insurance.type, 'ccw')}>
                  <i className="fa fa-undo" />
                </a>
                <a className="qf-cursor-pointer ml-3"
                   onClick={() => this.rotateImage(insurance.type, 'cw')}>
                  <i className="fa fa-undo fa-flip-horizontal" />
                </a>
              </div>
              <div>
                <span>Card Number: {insurance.cardNumber}</span>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };
  
  prepareInsurancesObjects = () => {
    let userInsurances = this.props.orderDetails.user.insuranceCards,
      insurancePrimaryArray = [],
      insuranceSecondaryArray = [];
    
    if (userInsurances.primaryCardImageURL) {
      insurancePrimaryArray.push({
        cardNumber: userInsurances.primaryCardNumber ? userInsurances.primaryCardNumber : '',
        cardImage: userInsurances.primaryCardImageURL ? this.constructImageLink(userInsurances.primaryCardImageURL) : Images.UPLOAD_PLACEHOLDER,
        title: 'Primary Insurance Card - Front',
        type: 'primaryFront'
      });
    }
    
    if (userInsurances.primaryCardBackImageURL) {
      insurancePrimaryArray.push({
        cardNumber: userInsurances.primaryCardNumber ? userInsurances.primaryCardNumber : '',
        cardImage: userInsurances.primaryCardBackImageURL ? this.constructImageLink(userInsurances.primaryCardBackImageURL) : Images.UPLOAD_PLACEHOLDER,
        title: 'Primary Insurance Card - Back',
        type: 'primaryBack'
      });
    }
    
    if (userInsurances.secondaryCardImageURL) {
      insuranceSecondaryArray.push({
        cardNumber: userInsurances.secondaryCardNumber ? userInsurances.secondaryCardNumber : '',
        cardImage: userInsurances.secondaryCardImageURL ? this.constructImageLink(userInsurances.secondaryCardImageURL) : Images.UPLOAD_PLACEHOLDER,
        title: 'Secondary Insurance Card - Front',
        type: 'secondaryFront'
      });
    }
    
    if (userInsurances.secondaryCardBackImageURL) {
      insuranceSecondaryArray.push({
        cardNumber: userInsurances.secondaryCardNumber ? userInsurances.secondaryCardNumber : '',
        cardImage: userInsurances.secondaryCardBackImageURL ? this.constructImageLink(userInsurances.secondaryCardBackImageURL) : Images.UPLOAD_PLACEHOLDER,
        title: 'Secondary Insurance Card - Back',
        type: 'secondaryBack'
      });
    }
    
    return {primary: insurancePrimaryArray, secondary: insuranceSecondaryArray};
  };
  
  generateInsuranceImageRow = (link, side, hasImage, card) => {
    let selectedSide = card === 'primary' ? this.state.insurancePrimaryArray : this.state.insuranceSecondaryArray;
    
    return (
      <div className="col-6 qf-insurance-image-wrapper">
        {hasImage ? (
          <div className="clickable" onClick={() => this.openSliderModal(selectedSide)}>
            <img src={link} className="img-fluid" alt="" />
          </div>
        ) : (
          <div>
            <img src={link} className="img-fluid" alt="" />
          </div>
        )}
        {strings['image_'+side]}
      </div>
    );
  };
  
  
  componentDidMount() {
    let insurancesArrays = this.prepareInsurancesObjects();
    
    this.setState({
      ...this.state,
      insurancePrimaryArray: insurancesArrays.primary,
      insuranceSecondaryArray: insurancesArrays.secondary
    });
  };
  
  render() {
    return(
      <div className="container">
        <div className="row qf-mb-100">
          <div className="col-1 light-blue-bg text-center pt-3">
            <span className="qf-page-icon">{Svgs.orders}</span>
          </div>
          <div className="col-11 white-bg px-5">
            
            <div className="row">
              <div className="col-3">
                <h2 className="qf-page-title text-capitalize">
                  <i className={this.statusIconClass(this.state.status)} title={this.fetchStatusLabel(this.state.status, true)}/>
                  {strings.Order} #{this.props.orderDetails.id}
                </h2>
              </div>
              <div className="col-6">
                <h2 className="qf-order-deleted text-capitalize">
                  {this.props.orderDetails.deletedAt ? strings.order_is_deleted : ''}
                </h2>
              </div>
              <div className="col-3 align-self-center text-right">
                <Link to={StaticRoutePaths.ORDERS} className="qf-back-btn">
                  <i className="fa fa-chevron-left" />
                  {strings.back}
                </Link>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <hr className="qf-divider-line" />
              </div>
            </div>
            
            <div className="row">

              <div className="col-8">
                <div className="row">
                  <div className="col-9 color-dark-gray">
                    {strings.medication_name}
                  </div>
                  <div className="col-1 color-dark-gray text-center p-0">
                    {strings.amount_label}
                  </div>
                  <div className="col-1 color-dark-gray text-center p-0">
                    {strings.price_label}
                  </div>
                  <div className="col-1 color-dark-gray text-center p-0">
                    {strings.subtotal_label}
                  </div>
                </div>
                {this.generateMedicationList()}
                <div className="row">
                  <div className="col-8">
                    {this.state.note && this.generateOrderInfoLine(strings.Notes, this.state.note)}
                  </div>
                  {this.generateOrderTotal()}
                </div>
              </div>

              <div className="col-4">
                {this.generateOrderInfoLine(strings.order_address, this.state.user.address.name)}
                {this.generateOrderInfoLine(strings.client_name, this.state.user.name)}
                {this.generateOrderInfoLine(strings.phone_number, this.state.user.phone)}
                
                <div className="row mb-1">
                  <div className="col-12 color-dark-gray">{strings.insurance_card} 1</div>
                  <div className="col-12 color-light-blue mb-1 qf-medium-text">{this.state.user.insuranceCards.primaryCardNumber}</div>
                  <div className="col-12 color-dark-gray">{strings.insurance_card} 2</div>
                  <div className="col-12 color-light-blue mb-1 qf-medium-text">{this.state.user.insuranceCards.secondaryCardNumber}</div>
                  <div className="col-12 color-light-blue mb-1">
                    <div className="row">
                      {this.generateInsuranceImageRow(this.state.user.insuranceCards.primaryCardImageURL, 'front', this.state.user.insuranceCards.hasPrimaryFront, 'primary')}
                      {this.generateInsuranceImageRow(this.state.user.insuranceCards.primaryCardBackImageURL, 'back', this.state.user.insuranceCards.hasPrimaryBack, 'primary')}
                    </div>
                  </div>
                  <div className="col-6 color-light-blue mb-1">
                    <div className="row">
                      {this.generateInsuranceImageRow(this.state.user.insuranceCards.secondaryCardImageURL, 'front', this.state.user.insuranceCards.hasSecondaryFront, 'secondary')}
                      {this.generateInsuranceImageRow(this.state.user.insuranceCards.secondaryCardBackImageURL, 'back', this.state.user.insuranceCards.hasSecondaryBack, 'secondary')}
                    </div>
                  </div>
                </div>
                
                {this.generateOrderInfoLine(this.props.orderDetails.is_drugstore ? strings.Druggist : strings.Pharmacist, this.state.pharmacistName)}
                {this.generateOrderInfoLine(strings.Received, this.state.createdOn,1)}
                {this.generateOrderInfoLine(strings.Read, this.state.activeOn,1)}
                {this.generateOrderInfoLine(strings.Taken + '/' + strings.Sent, this.state.completedOn)}
                
                <div className="row mb-1">
                  <div className="col-6 color-dark-gray">
                    {strings.order_status}
                    {this.state.savingStatus ? <i className="fa fa-spinner fa-spin ml-2" /> : null}
                    {this.state.statusError ? <i className="qf-color-red ml-2">{strings.error}</i> : null}
                  </div>
                  <div className="col-6 color-dark-gray">
                  {!this.props.orderDetails.deletedAt ? (
                    <div className="qf-delete-btn">
                      <h2 className="qf-medium-text color-light-blue text-capitalize"
                          onClick={this.state.status === 'ready' || this.state.status === 'canceled' ? this.deleteOrderModal : this.infoOrderModal }>
                        <i className="fa fa-trash-o mr-2" />
                        {strings.delete_order}
                      </h2>
                    </div>
                  ) : ''}
                  </div>
                  {this.generateStatus('pending', strings.pending_order, true)}
                  {this.generateStatus('inTransit', strings.accept_order, this.state.status !== 'pending')}
                  {this.generateStatus('canceled', strings.cancel_order, this.state.status !== 'pending')}
                  {this.generateStatus('ready', strings.order_ready, this.state.status !== 'inTransit')}
                </div>
                
                <Modal
                  visible={this.state.modalMedicationImageOpen}
                  onClickBackdrop={this.closeMedicationImageModal}
                  className="qf-image-preview-modal"
                  dialogClassName="qf-image-preview-content"
                >
                 
                 
                  {this.state.activeMedicationImageURL !== '' ? (
                    
                  <div className="col-12 h-100 qf-active-medication-modal">
                    <div className="">
                      <div className="qf-h-90 text-center" ref={div => (this['activeMedicationImageHolder'] = div)}>
                        <span className="qf-helper" />
                        <div className="qf-slider-img">
                          <img 
                            src={this.state.activeMedicationImageURL}
                            style={this.generateStyle('activeMedicationImage')}
                            alt=""
                            className="mx-auto"
                          />
                        </div>
                      </div>
                      <div className="qf-h-10 text-center p-2">
                        <a 
                          className="qf-cursor-pointer mr-3"
                          onClick={() => this.rotateImage('activeMedicationImage', 'ccw')}
                        >
                          <i className="fa fa-undo" />
                        </a>
                        <a 
                          className="qf-cursor-pointer ml-3"
                          onClick={() => this.rotateImage('activeMedicationImage', 'cw')}
                        >
                          <i className="fa fa-undo fa-flip-horizontal" />
                        </a>
                      </div>
                    </div>
                    <a onClick={this.closeMedicationImageModal} className="qf-close-modal">
                      <i className="fa fa-times-circle" />
                    </a>
                  </div>
              
                  ) : ''}
                </Modal>

                <Modal
                  visible={this.state.modalStatusMsgOpen}
                  className="qf-status-msg-modal"
                  dialogClassName="qf-status-msg-content"
                  onClickBackdrop={this.closeStatusMsgModal}
                >
                  <i className="fa fa-times qf-close-modal-btn clickable" onClick={this.closeStatusMsgModal} />
                  <div className="row">
                    <div className="col-12 qf-info-bubble text-center mt-5">
                      {Svgs.infoBubble}
                    </div>
                    <div className="col-12 text-center mt-4 qf-status-message-title">
                      {strings.write_a_msg}
                    </div>
                    <div className="col-12 text-center mt-1">
                          <textarea
                            className="qf-textarea-customer-msg"
                            value={this.state.statusMessage}
                            onInput={this.updateStatusMessage}>
                            </textarea>
                    </div>
                    
                    <div className="col-12 text-center mt-1">
                      <div className="qf-fake-radio-btn-circle mr-2">
                        <div className="qf-fake-radio-btn-dot"> </div>
                      </div>
                      <label className="color-blue">
                        {this.fetchStatusLabel(this.state.status)}
                      </label>
                    </div>
                    
                    {this.state.savingMessage ? (
                      <div className="col-12 text-center mt-4">
                        <i className="fa fa-spinner fa-spin ml-2" />
                      </div>
                    ) : (
                      <div className="col-12 text-center mt-4">
                        <MainBtn onclick={this.closeStatusMsgModal} title={strings.cancel} extraClasses="qf-cancel-change-msg mr-1 qf-min-100" />
                        <MainBtn onclick={this.changeStatusMessage} title={strings.change_status} extraClasses="qf-blue-btn ml-1 qf-min-100" />
                      </div>
                    )}
                  
                  </div>
                </Modal>

                <Modal
                  visible={this.state.modalDeleteOrder}
                  className="qf-status-msg-modal"
                  dialogClassName="qf-status-msg-content"
                  onClickBackdrop={this.closeDeleteOrderModal}
                >
                  <i className="fa fa-times qf-close-modal-btn clickable" onClick={this.closeDeleteOrderModal} />
                  <div className="row">
                    <div className="col-12 qf-info-bubble text-center mt-5">
                      {Svgs.infoBubble}
                    </div>
                    <div className="col-12 text-center mt-4 qf-status-message-title">
                      {strings.delete_order_msg}
                    </div>
                    
                    {this.state.savingMessage ? (
                      <div className="col-12 text-center mt-4">
                        <i className="fa fa-spinner fa-spin ml-2" />
                      </div>
                    ) : (
                      <div className="col-12 text-center mt-4">
                        <MainBtn onclick={this.closeDeleteOrderModal} title={strings.cancel} extraClasses="qf-cancel-change-msg mr-1 qf-min-100" />
                        <MainBtn onclick={this.deleteOrder} title={strings.delete_order} extraClasses="qf-blue-btn ml-1 qf-min-100" />
                      </div>
                    )}
                  
                  </div>
                </Modal>

                <Modal
                  visible={this.state.modalInfoOrder}
                  className="qf-status-msg-modal"
                  dialogClassName="qf-status-msg-content"
                  onClickBackdrop={this.closeInfoOrderModal}
                >
                  <i className="fa fa-times qf-close-modal-btn clickable" onClick={this.closeInfoOrderModal} />
                  <div className="row">
                    <div className="col-12 qf-info-bubble text-center mt-5">
                      {Svgs.infoBubble}
                    </div>
                    <div className="col-12 text-center mt-4 qf-status-message-title">
                      {strings.delete_order_info}
                    </div>
                  </div>
                </Modal>
                
                <Modal
                  visible={this.state.modalSliderOpen}
                  className="qf-image-preview-modal"
                  dialogClassName="qf-image-preview-content"
                  onClickBackdrop={this.closeSliderModal}
                >
                  {this.state.selectedInsuranceCard ? (
                    <div className="modal-body h-100">
                      <div className="row h-100 align-items-center">
                        <div className="ExampleSliders">
                          <Slider
                            loop={ false }
                            showArrows={ true}
                            //showNav={ true }
                            selected={ 0 }
                          >
                            {this.generateInsuranceCardSlides()}
                          </Slider>
                        </div>
                      </div>
                    </div>
                  ) : ''}
                </Modal>
              
              </div>
            </div>
          
          </div>
        </div>
      </div>
    );
  }
}

export default OrderDetails;



// WEBPACK FOOTER //
// ./src/customModules/Orders/component-order-details.js